import LeaseComparison from "@survey-components/comparisonPreview/LeaseComparison";
import PropertyComparison from "@survey-components/comparisonPreview/PropertyComparison";
import CoverSectionPreview from "@survey-components/coverPreview/CoverSectionPreview";
import MarketMapWrapper from "@survey-components/preview/MarketMapWrapper";
import CustomSectionPreview from "@survey-preview/CustomSectionPreview";
import TourScheduleSectionPreview from "@survey-preview/TourScheduleSectionPreview";
import { SurveySection } from "@survey-types/survey.section.types";
import PropertyDetailsWithFilter from "./PropertyDetailsWithFilter";

interface SectionRendererProps {
  section: SurveySection;
  propertyId?: string;
}

/**
 * Renderer component for different survey section types
 * Handles rendering of custom and predefined sections with proper filtering
 */
const SectionRenderer = ({ section, propertyId }: SectionRendererProps) => {
  // Handle custom sections
  if (section.isCustom) {
    return (
      <div
        key={section.surveySectionId}
        data-section-id={section.surveySectionId}
        className="flex flex-col"
      >
        <CustomSectionPreview section={section} mode="PDFPreview" />
      </div>
    );
  }

  const sectionName = section.name?.replace(/\s/g, "").toLowerCase()?.trim();

  // Handle predefined sections
  switch (sectionName) {
    case "cover":
      return (
        <div
          key={section.surveySectionId}
          data-section-id={section.surveySectionId}
          className="flex flex-col"
        >
          <CoverSectionPreview mode="PDFPreview" />
        </div>
      );
    case "properties":
      return (
        <div
          key={section.surveySectionId}
          data-section-id={section.surveySectionId}
          className="flex flex-col"
        >
          <PropertyDetailsWithFilter propertyFilter={propertyId} />
        </div>
      );
    case "marketmap":
      return (
        <div
          key={section.surveySectionId}
          data-section-id={section.surveySectionId}
          className="flex flex-col"
        >
          <MarketMapWrapper key={section.surveySectionId} mode="PDFPreview" />
        </div>
      );
    case "tourschedule":
      return (
        <div
          key={section.surveySectionId}
          data-section-id={section.surveySectionId}
          className="flex flex-col"
        >
          <TourScheduleSectionPreview mode="PDFPreview" />
        </div>
      );
    case "propertycomparison":
      return (
        <div
          key={section.surveySectionId}
          data-section-id={section.surveySectionId}
          className="flex flex-col"
        >
          <PropertyComparison />
        </div>
      );
    case "leasecomps":
      return (
        <div
          key={section.surveySectionId}
          data-section-id={section.surveySectionId}
          className="flex flex-col"
        >
          <LeaseComparison />
        </div>
      );
    default:
      return (
        <div className="p-4 text-center text-gray-500">
          Section &ldquo;{section.name}&rdquo; preview not available
        </div>
      );
  }
};

export default SectionRenderer;
